export { type WordPrcData, wordPrcDataTable } from "#word-prc-data-table";
